import MenuItem from '@mui/material/MenuItem';
import {
  gridSortModelSelector,
  GridColumnMenuFilterItem,
  GridColumnMenuHideItem,
  GridColumnMenuManageItem,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-pro';
import type {
  GridColumnMenuItemProps,
  GridLocaleText,
  GridSortDirection,
} from '@mui/x-data-grid-pro';
import type { MouseEvent, ReactElement } from 'react';

const SORT_ITEMS: {
  direction: GridSortDirection;
  label: keyof GridLocaleText;
}[] = [
  { direction: null, label: 'columnMenuUnsort' },
  { direction: 'asc', label: 'columnMenuSortAsc' },
  { direction: 'desc', label: 'columnMenuSortDesc' },
];

export function ColumnMenu5SortItems({
  colDef,
  onClick,
}: GridColumnMenuItemProps): ReactElement | null {
  const apiRef = useGridApiContext();
  const sortModel = useGridSelector(apiRef, gridSortModelSelector);
  if (!colDef.sortable) {
    return null;
  }
  const current =
    sortModel.find((item) => item.field === colDef.field)?.sort ?? null;
  return (
    <>
      {SORT_ITEMS.map(({ direction, label }) => (
        <MenuItem
          key={label}
          disabled={direction === current}
          onClick={(event: MouseEvent) => {
            onClick(event);
            apiRef.current.sortColumn(colDef.field, direction);
          }}
        >
          {apiRef.current.getLocaleText(label)}
        </MenuItem>
      ))}
    </>
  );
}

// MUI X draws a divider between column-menu slots, so the items MUI X 5 showed
// as one group share a slot.
export function ColumnMenu5Items(props: GridColumnMenuItemProps): ReactElement {
  return (
    <>
      <ColumnMenu5SortItems {...props} />
      <GridColumnMenuFilterItem {...props} />
      <GridColumnMenuHideItem {...props} />
      <GridColumnMenuManageItem {...props} />
    </>
  );
}
